import React from 'react';
import { UserRoundIcon } from 'lucide-react';
type AvatarProps = {
  size?: 'lg' | 'md';
  label?: string;
  src?: string;
};
export function Avatar({
  size = 'lg',
  label = 'Portrait of the owner of Swift Errands',
  src
}: AvatarProps) {
  const dimension = size === 'lg' ? 'h-64 w-64 sm:h-80 sm:w-80' : 'h-40 w-40 sm:h-52 sm:w-52';
  const ring = size === 'lg' ? 'ring-8' : 'ring-[6px]';
  if (src) {
    return <img src={src} alt={label} className={`${dimension} ${ring} rounded-full object-cover object-top ring-purple ring-offset-4 ring-offset-white shadow-soft`} data-id="element-14" data-mp="6xy4xyfu4230" />;
  }
  return <div role="img" aria-label={label} className={`${dimension} ${ring} flex items-center justify-center rounded-full bg-lavender ring-purple ring-offset-4 ring-offset-white shadow-soft`} data-id="element-15" data-mp="gxgnqbk0dhth">
      <UserRoundIcon className={size === 'lg' ? 'h-24 w-24 text-purple/40' : 'h-16 w-16 text-purple/40'} strokeWidth={1.25} aria-hidden="true" data-id="element-16" data-mp="2iojzx59jr4g5" />
    </div>;
}